import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import { autocomplete, resetAutocomplete } from '../../actions/search-actions';


const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;
const MIN_LENGTH_FOR_SEARCH = 3;

class SearchField extends React.Component {

    state = {
        query: '',
        timer: null
    }

    triggerChange = () => {
        const {props: {autocomplete, resetAutocomplete}, state: {query}} = this;

        //something is in search input
        if (query && query.length >= MIN_LENGTH_FOR_SEARCH) {
            autocomplete( query );
        } else {
            resetAutocomplete();
        }
    }

    handleChange = (e) => {
        const {state: {timer}, triggerChange} = this;
        clearTimeout(timer);

        this.setState({
            query: e.currentTarget.value.trimLeft(),
            timer: setTimeout(triggerChange, WAIT_INTERVAL)
        });

    }

    handleKeyDown = (e) => {
        const {triggerChange} = this;

        if (e.keyCode === ENTER_KEY) {
            triggerChange();
        }
    }

    handleReset = (e) => {
        const {props: {resetAutocomplete}, state: {query}} = this;

        this.setState({
            query: '',
            timer: null
        });

        resetAutocomplete();

    }

    render() {
        const {props: {search: {results}}, state: {query}, handleChange, handleKeyDown, handleReset} = this;
        
        
        return (
                <React.Fragment>
                    <input type="text" 
                           name="q"
                           onChange={handleChange} 
                           onKeyDown={handleKeyDown} 
                           autoComplete="off" 
                           value={query} 
                           className="search-input" 
                           placeholder={ this.props.t( 'search.placeholder' ) }/>
                           
                    { !results && <button type="submit" className="search-button">
                        <span className="glyphicon glyphicon-search "></span> 
                    </button>
                    }
                
                    { results && <button onClick={handleReset} 
                                         className="search-button">
                        <span className="glyphicon glyphicon-remove "></span> 
                    </button>
                    }
                </React.Fragment>
                );
    }

}

const mapStateToProps = (state) => ({
    search: state.search
});

const mapDispatchToProps = (dispatch) => bindActionCreators( {
    autocomplete,
    resetAutocomplete
}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( SearchField ));